import { render, staticRenderFns } from "./QuickNotifications.vue?vue&type=template&id=6ed6296a&"
import script from "./QuickNotifications.vue?vue&type=script&lang=js&"
export * from "./QuickNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports